import React from 'react'
import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { errorTypes } from '@/utility/validation'
import { useFormContext } from 'react-hook-form'
import type { OnboardTabProps } from './onboard.types'

const OnboardAdvanceDetails: React.FC<OnboardTabProps> = ({ isLoading, handleNextStep }) => {
    const methods = useFormContext()
    const { register, formState: { errors } } = methods

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                <FormField
                    {...register("aadharNumber", { ...errorTypes.required('Aadhar Number'), ...errorTypes.aadhaar })}
                    label="Aadhar Number"
                    placeholder="Aadhar number"
                    type="text"
                    maxLength={12}
                    error={errors.aadharNumber?.message as string}
                />
                <FormField
                    {...register("panNumber", { ...errorTypes.required('Pan card number'), ...errorTypes.pan })}
                    label="PAN Number"
                    placeholder="Enter pan number"
                    type="text"
                    pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
                    maxLength={10}
                    error={errors.panNumber?.message as string}
                />
                <FormField
                    {...register("uanNumber", { ...errorTypes.required('UAN Number') })}
                    label="UAN Number"
                    placeholder="Enter uan number"
                    type="text"
                    maxLength={12}
                    error={errors.uanNumber?.message as string}
                />
                <FormField
                    {...register("esicNumber", { ...errorTypes.required('ESIC Number') })}
                    label="ESIC Number"
                    placeholder="Enter esic number"
                    type="text"
                    maxLength={10}
                    error={errors.esicNumber?.message as string}
                />
                <FormField
                    {...register("pfNumber", { ...errorTypes.required('PF Number') })}
                    label="PF Number"
                    placeholder="Enter pf number"
                    type="text"
                    maxLength={22}
                    error={errors.pfNumber?.message as string}
                />
                <FormField
                    {...register("insuranceNumber", { ...errorTypes.required('Insurance Number') })}
                    label="Insurance Number"
                    placeholder="Enter insurance number"
                    type="text"
                    maxLength={25}
                    error={errors.insuranceNumber?.message as string}
                />
                <FormField
                    {...register("drivingLicenseNumber", { ...errorTypes.required('Driving License Number') })}
                    label="Driving License Number"
                    placeholder="Driving license number"
                    type="text"
                    maxLength={17}
                    error={errors.drivingLicenseNumber?.message as string}
                />
            </div>
            <div className="flex items-center justify-end mt-6">
                <Button
                    type="button"
                    onClick={() => handleNextStep('tab4', ['aadharNumber', 'panNumber', 'uanNumber', 'esicNumber', 'pfNumber', 'insuranceNumber', 'drivingLicenseNumber'])}
                >
                    {isLoading ? <Spinner /> : 'Save and Continue'}
                </Button>
            </div>
        </>
    )
}

export default OnboardAdvanceDetails
